export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => (element, parentModule) => {
        if (parentModule) {
          let columns = rootGetters['componentRowModule/elements'](element, parentModule).columns
          return Object.prototype.hasOwnProperty.call(element, 'componentColumn') ? columns[element.componentColumn] : columns
        }
        let columns = rootGetters['componentRowModule/elements'](element).columns
        return Object.prototype.hasOwnProperty.call(element, 'componentColumn') ? columns[element.componentColumn] : columns
    },
    id: (state, getters) => (element) => getters.elements(element).id,
    index: (state, getters) => (element, id, parentModule) => getters.elements(element, parentModule).findIndex(component => component.id == id),
    name: (state, getters) => element => getters.elements(element).name,
    styles: (state, getters) => (element, styles = 'styles', parentModule) => getters.elements(element, parentModule)[styles],
    assets: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).assets,
    properties: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).properties,
    classes: (state, getters) => (element, classes = 'classes', parentModule) => getters.elements(element, parentModule)[classes],
    background: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).background,
  },
  actions: {
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'componentColumnModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'componentColumnModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'componentColumnModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'componentColumnModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
  }
}